import { fields } from "@monorepo/utils/src/variables/projectsData/receiptFromOikView/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.OIK_NAME]: [],
  [fields.DATE_FROM]: "",
  [fields.DATE_TO]: "",
  [fields.TK_TYPE]: [],
});
